import RequestManager from '@ember-data/request';
import Fetch from '@ember-data/request/fetch';
import { setOwner, getOwner } from '@ember/application';
import AuthHandler from '../request/auth-handler.js';
import BaseUrlHandler from '../request/base-url-handler.js';

export default class AppRequestManager extends RequestManager {
  constructor(args) {
    super(args);

    const authHandler = new AuthHandler();
    const baseUrlHandler = new BaseUrlHandler();

    setOwner(authHandler, getOwner(this));
    setOwner(baseUrlHandler, getOwner(this));

    this.use([baseUrlHandler, authHandler, Fetch]);
  }
}
